import { trpc, TrpcInputs, TrpcOutputs } from '../../config/trpc';

type ContactsOutput = TrpcOutputs['getContacts'];
type ContactsInput = TrpcInputs['getContacts'];
type UseContacts = [ContactsOutput, boolean, string?];

export const useContacts = (contact?: Partial<ContactsInput>): UseContacts => {
  const { data, isLoading, error } = trpc.getContacts.useQuery({ ...contact } as ContactsInput, {
    refetchOnWindowFocus: false,
  });

  return [data, isLoading, error?.message] as const;
};
